export default {
  'home.banner.description':
    'Manage your workshop through Ultracar in an easy way and make it profit.',
  'home.banner.button.signin': 'Sign In',
  'home.banner.button.freeTrial': 'Free Trial',
};
